import PropTypes from "prop-types";
import React, { Component } from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

import menuConfig from "./menuConfig"; // Import file menu

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = item => {
    item.classList.add("active");
    let parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    while (parent) {
      parent.classList.add("mm-active");
      const grandParent = parent.parentElement.closest("li");
      if (grandParent) {
        grandParent.classList.add("mm-show");
      }
      parent = grandParent;
    }
    this.scrollElement(item);
  };

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current && item) {
        const currentPosition = item.offsetTop;
        if (currentPosition > window.innerHeight) {
          this.refDiv.current.getScrollElement().scrollTop = currentPosition - 300;
        }
      }
    }, 300);
  };

  renderItem = (item, t) => {
    if (item.children) {
      return (
        <li key={item.title}>
          <Link to="#" className="has-arrow">
            {item.badge && <span className="badge rounded-pill bg-danger float-end">{t(item.badge)}</span>}
            <i className={item.icon}></i>
            <span>{t(item.title)}</span>
          </Link>
          <ul className="sub-menu mx-1" aria-expanded="false">
            {item.children.map(child => (
              <li key={child.path}>
                <Link to={child.path}>
                  <i className={child.icon}></i>
                  <span>{t(child.label)}</span>
                </Link>
              </li>
            ))}
          </ul>
        </li>
      );
    } else {
      return (
        <li key={item.path}>
          <Link to={item.path}>
            {item.badge && <span className="badge rounded-pill bg-danger float-end">{t(item.badge)}</span>}
            <i className={item.icon}></i>
            <span>{t(item.label)}</span>
          </Link>
        </li>
      );
    }
  };

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{t("Danh mục")}</li>
              {menuConfig.map(item => this.renderItem(item, t))}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));
